import { render, staticRenderFns } from "./browse.vue?vue&type=template&id=164854f0&scoped=true"
import script from "./browse.vue?vue&type=script&lang=js"
export * from "./browse.vue?vue&type=script&lang=js"
import style0 from "./browse.vue?vue&type=style&index=0&id=164854f0&prod&scoped=true&lang=scss"
import style1 from "./browse.vue?vue&type=style&index=1&id=164854f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164854f0",
  null
  
)

export default component.exports